const svg = "oaes44uyqq";

export { svg };
import "./atom.relief-svg.style.linaria.module.css";
//# sourceMappingURL=atom.relief-svg.style.js.map
